module.exports = __webpack_public_path__ + "static/media/profile-cover.798570bb.jpg";